import * as React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Breadcrumb} from '~/components/Breadcrumps';
import {usersLinks} from '~/modules/Users/links';
import {UsersView} from '~/modules/Users/views/UsersView';
import {UserView} from '~/modules/Users/views/UserView';

export * from './links';

export const UsersRouter = () => <Breadcrumb breadcrumb={{
    to: usersLinks.users(),
    title: 'Users'
}}
>
    <Routes>
        <Route index element={<UsersView/>}/>
        <Route path=":userId" element={<UserView/>}/>
        <Route path="*" element={<Navigate to={usersLinks.users()} replace />}/>
    </Routes>
</Breadcrumb>;
